import React from "react";
import PropTypes from "prop-types";
import { TwoColumn, TwoRow } from "core/layouts";
import useResponsive from "core/hooks/useResponsive";
import variables from "../../themes/base/styles/variables";

const authLayoutStyle = {
  columnSectionsStyle: {
    width: variables.halfWidth,
    overflowY: "auto",
  },
  topSectionStyle: {
    height: variables.halfHeight,
    position: "fixed",
    zIndex: 1,
  },
  topRowStyle: { position: "relative" },
  bottomSectionStyle: { marginTop: variables.halfHeight },
};
function AuthLayout({ className, style, leftSection, rightSection }) {
  const responsive = useResponsive();
  return responsive.isMd ? (
    <TwoColumn
      className={className}
      style={style}
      leftSection={leftSection}
      leftSectionStyle={authLayoutStyle.columnSectionsStyle}
      rightSection={rightSection}
      rightSectionStyle={authLayoutStyle.columnSectionsStyle}
      isRightFillSpace
    />
  ) : (
    <TwoRow
      style={authLayoutStyle.topRowStyle}
      className={className}
      topSection={rightSection}
      topSectionStyle={authLayoutStyle.topSectionStyle}
      bottomSection={leftSection}
      bottomSectionStyle={authLayoutStyle.bottomSectionStyle}
    />
  );
}

AuthLayout.defaultProps = {
  className: "",
  style: {},
};

AuthLayout.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default AuthLayout;
